import React, { useRef, useState } from 'react';
import { useAppDispatch } from 'store/hooks';

import templateFile from './import-admins.xlsx';

import { finishImportAdmins } from 'store/admins/actions';

import { useFileUpload } from './ImportAdmins.hooks';

import ImportAdmins from './ImportAdmins';

type SwiperWithSlideNext = { slideNext: () => void };

const ImportAdminsContainer = ({
  schoolId,
  onClose,
  ...restProps
}: { schoolId: string; onClose: any } & Record<string, any>) => {
  const dispatch = useAppDispatch();

  const swiperRef = useRef<SwiperWithSlideNext | null>(null);

  const [importedAdmins, setImportedAdmins] = useState([]);

  const handleUploaded = (response: any) => {
    setImportedAdmins(response);

    swiperRef.current?.slideNext();
  };

  const [percentage, uploadError, handleDropAccepted, handleDropRejected] =
    useFileUpload({
      onUploaded: handleUploaded,
    });

  const handleSwiper = (swiper: any) => {
    swiperRef.current = swiper;
  };

  const handleDownloadTemplateClick = () => {
    const link = document.createElement('a');

    link.href = templateFile;

    link.setAttribute('download', 'import-admins-template.xlsx');

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);
  };

  const handleImportClick = async () => {
    try {
      await dispatch(
        finishImportAdmins({
          schoolId,
          data: {
            admins: importedAdmins
              .filter(
                (importedAdmin: any) => importedAdmin.status === 'SUCCESS',
              )
              .map((importedAdmin: any) => ({
                email: importedAdmin.email,
                firstName: importedAdmin.firstName,
                lastName: importedAdmin.lastName,
              })),
          },
        }),
      ).unwrap();

      onClose();
    } catch (error) {
      console.warn(error);
    }
  };

  return (
    <ImportAdmins
      {...restProps}
      importedAdmins={importedAdmins}
      percentage={percentage}
      uploadError={uploadError}
      onDropAccepted={handleDropAccepted}
      onDropRejected={handleDropRejected}
      onClose={onClose}
      onSwiper={handleSwiper}
      onImportClick={handleImportClick}
      onDownloadTemplateClick={handleDownloadTemplateClick}
    />
  );
};

export default React.memo(ImportAdminsContainer) as any;
